import { Directive, Input, TemplateRef, ViewContainerRef, inject, OnInit } from '@angular/core';

import { UserRole } from '@app/core/auth/user-role.enum';
import { AuthService } from '@app/core/services/auth-service/auth.service';

@Directive({
  selector: '[appHasRole]',
  standalone: true,
})
export class RoleBasedAccessDirective implements OnInit {
  private authService = inject(AuthService);
  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);

  @Input('appHasRole') allowedRoles: UserRole[] = [];

  ngOnInit() {
    const userRoles = this.authService.userRoles();
    const hasRole = this.allowedRoles.length === 0 || this.allowedRoles.some(role => userRoles.includes(role));

    if (hasRole) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
